var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 53.15",
    style: {
      enableBackground: "new 0 0 120 53.15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#007953;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h36.61v53.15H0V0z M28.94,7.91v7.44h-5.67v29.88h-9.8V15.35H7.8V7.91H28.94z M108.43,7.91l5.55,37.32 h-9.92l-0.59-6.73h-3.43l-0.59,6.73H89.41l4.96-37.32H108.43z M103.23,31.89c-0.47-4.25-0.94-9.45-1.42-15.71 c-0.94,7.2-1.65,12.4-1.89,15.71H103.23z M48.78,7.91h7.2c4.72,0,7.91,0.24,9.57,0.59c1.65,0.47,2.95,1.18,3.78,2.13 c0.83,1.06,1.42,2.13,1.54,3.31c0.24,1.18,0.35,3.54,0.35,7.09v13.11c0,3.31-0.12,5.55-0.47,6.73c-0.35,1.06-0.83,2.01-1.65,2.6 c-0.71,0.71-1.77,1.06-2.83,1.42c-1.18,0.24-2.95,0.35-5.2,0.35H48.78V7.91z M58.46,14.29v24.57c1.42,0,2.24-0.24,2.6-0.83 c0.35-0.59,0.47-2.13,0.47-4.61V18.9c0-1.65-0.12-2.72-0.12-3.19c-0.12-0.47-0.35-0.83-0.83-1.06 C60.24,14.41,59.53,14.29,58.46,14.29L58.46,14.29z M83.39,0H120v53.15H83.39V0z M87.52,4.13h28.35v44.88H87.52V4.13z M41.69,0 h36.61v53.15H41.69V0z M45.83,4.13h28.35v44.88H45.83V4.13z M4.13,4.13h28.35v44.88H4.13V4.13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTda);
export default __webpack_public_path__ + "static/media/tda.409a5e24cda2a36f390e4fb4b4b0f37d.svg";
export { ForwardRef as ReactComponent };